import browser from 'browser-detect';
import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromRoot from '../state';
import * as rootActions from '../state/app.actions';

import { environment as env } from '../../environments/environment';

import {
  LocalStorageService,
  routeAnimations,
  selectEffectiveTheme,
  selectSettingsLanguage,
  selectSettingsStickyHeader
} from '../core/core.module';
import {
  actionSettingsChangeAnimationsPageDisabled,
  actionSettingsChangeLanguage,
  actionSettingsChangeTheme
} from '../core/settings/settings.actions';
import { SessionService } from 'app/global/services/session.service';
import { MiniUserModel } from '../shared/data/models/mini-user.model';
import { skipWhile } from 'rxjs/operators';

import { SettingsState, State } from '../core/settings/settings.model';
import { selectSettings } from '../core/settings/settings.selectors';
import { Meta } from '@angular/platform-browser';

import { toggleShowThreads } from '../home/state/actions/dm.action';
import { CacheService } from '../image-loader/services/cache.service';

@Component({
  selector: 'anms-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeAnimations]
})
export class AppComponent implements OnInit {
  isProd = env.production;
  envName = env.envName;
  version = env.versions.app;
  year = new Date().getFullYear();
  logo = require('../../assets/images/gscroll-logo.png');
  logoalt = require('../../assets/images/gscroll-logo.png');
  languages = ['en', 'de', 'sk', 'fr', 'es', 'pt-br', 'zh-cn', 'he'];
  navigation = [{ link: '', label: 'Home' }];
  navigationSideMenu = [
    ...this.navigation
    // { link: 'settings', label: 'anms.menu.settings' }
  ];
  settings$: Observable<SettingsState>;

  stickyHeader$: Observable<boolean>;
  language$: Observable<string>;
  theme$: Observable<string>;

  // my variables
  currentUser$: Observable<MiniUserModel>;
  currentUserLoading$: Observable<boolean>;
  currentUserError$: Observable<string>;
  isAuthenticated$: Observable<boolean>;

  tempUser: MiniUserModel;

  constructor(
    private store: Store,
    private storageService: LocalStorageService,
    private myStore: Store<fromRoot.State>,
    private sessionService: SessionService,
    private appStore$: Store<State>,
    private metaService: Meta,
    private imageCache: CacheService
  ) {
    metaService.addTags([
      { name: 'og:title', content: `Global Scroll` },
      { name: 'og:description', content: `GScroll - Free speech, forever!` },
      {
        name: 'og:image',
        content: `https://gscroll.com/assets/images/gscroll-sq.png`
      },
      { name: 'og:url', content: `https://gscroll.com` },
      { name: 'og:image:type', content: 'image/png' },
      { name: 'og:image:width', content: '1024' },
      { name: 'og:image:height', content: '1024' }
    ]);
  }

  private static isIEorEdgeOrSafari() {
    return ['ie', 'edge', 'safari'].includes(browser().name);
  }

  ngOnInit(): void {
    // initialize the cache
    // this.imageCache.init({
    //   cacheClearSize: 100
    // });

    this.storageService.testLocalStorage();
    if (AppComponent.isIEorEdgeOrSafari()) {
      this.store.dispatch(
        actionSettingsChangeAnimationsPageDisabled({
          pageAnimationsDisabled: true
        })
      );
    }

    this.stickyHeader$ = this.store.pipe(select(selectSettingsStickyHeader));
    this.language$ = this.store.pipe(select(selectSettingsLanguage));
    this.theme$ = this.store.pipe(select(selectEffectiveTheme));

    /*
     * from my store
     * */
    this.currentUser$ = this.myStore.select(fromRoot.getMe);
    this.currentUserLoading$ = this.myStore.select(fromRoot.getUserLoading);
    this.currentUserError$ = this.myStore.select(fromRoot.getUserError);
    this.isAuthenticated$ = this.myStore.select(fromRoot.getIsAuthenticated);

    this.myStore
      .select(fromRoot.getMe)
      .pipe(skipWhile(u => !u))
      .subscribe(user => {
        if (this.tempUser?.ID !== user?.ID) {
          this.store.dispatch(new rootActions.UserSubscription());
          this.tempUser = user;
        }
      });
    this.settings$ = this.appStore$.pipe(select(selectSettings));
  }

  onThemeSelect(theme) {
    this.appStore$.dispatch(actionSettingsChangeTheme({ theme: theme }));
  }

  onLogoutClick() {
    // this.store.dispatch(authLogout());
    this.sessionService.logout();
  }

  onLanguageSelect({ value: language }) {
    this.store.dispatch(actionSettingsChangeLanguage({ language }));
  }

  toggleShowThreads(): void {
    this.store.dispatch(toggleShowThreads());
  }
}
